module.exports = __webpack_public_path__ + "img/carddage-gift.8412adb0.png";